import { useState } from "react";
import { Box, Button, Divider, Popover, Tooltip } from "@mui/material";
import infoIcon from "../../../assets/info-svgrepo-com.svg";
import { messages } from "../../../constants/commonMessages";

import "./cellInfoMenu.scss";
import Label from "../../Label/Label";

const CellInfoMenu = ({
  coordinatesValues,
  clearMappings,
  isDisable,
  // keyCoordinatesValues,
  role,
}) => {
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const onClickClearMappings = (type) => {
    setOpen(null);
    clearMappings(type);
  };

  return (
    <>
      <button
        aria-label="more"
        aria-controls="long-menu"
        id="long-button"
        className="readMore-btn-cell-info"
        disabled={isDisable}
        aria-haspopup="true"
        onClick={handleOpen}
      >
        <img src={infoIcon} alt="Info Icon"></img>
      </button>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        className="info-popup"
        PaperProps={{
          sx: {
            m: 2,
            width: 180,
          },
        }}
      >
        {/* {role === "preProcessor" && (
          <>
            <Box class="detail-popup">
              <Box className="popup-details">
                <Label
                  text={`${messages?.SELECTED_KEY_COORDINATES} - `}
                  padding="0px 4px"
                  fontWeight="600"
                />

                <Label
                  text={`${
                    keyCoordinatesValues?.length >= 0
                      ? keyCoordinatesValues?.length
                      : 0
                  }`}
                  fontWeight="600"
                />
              </Box>
            </Box>

            <Divider variant="middle" />

            <Box class="detail-popup">
              <Box>
                <Label
                  text={keyCoordinatesValues?.toString()}
                  wordBreak="break-word"
                  fontSize="13px"
                />
              </Box>
            </Box>
            <Divider className="border-dash" />
          </>
        )} */}

        <Box class="detail-popup">
          <Box className="popup-details">
            <Label
              text={`${messages?.SELECTED_COORDINATES} -`}
              padding="0px 4px"
              fontWeight="600"
            />

            <Label
              text={`${
                coordinatesValues?.length >= 0 ? coordinatesValues?.length : 0
              }`}
              fontWeight="600"
            ></Label>
          </Box>
        </Box>

        <Divider variant="middle" />

        <Box class="detail-popup">
          <Box>
            <Label
              text={coordinatesValues?.toString()}
              wordBreak="break-word"
              fontSize="13px"
            ></Label>
          </Box>
        </Box>

        <Divider variant="border-dash" />

        <Box className="clear-wrap-btn">
          <Tooltip
            arrow
            title={role === "processor" ? messages?.RESET_MAPPING_TOOLTIP : ""}
          >
            <Button
              fullWidth
              disableRipple
              // onClick={(e) => onClickClearMappings("toResetKeyValueMapping")}
              onClick={(e) => onClickClearMappings("toResetValueMapping")}
            >
              {messages?.RESET_MAPPINGS}
            </Button>
          </Tooltip>
        </Box>
      </Popover>
    </>
  );
};

export default CellInfoMenu;
